<div class="mila-ms" (keydown)="onKeydown($event)" (appClickOutside)="close()">

  <div class="field-input field-input--tag mila-ms__field" (mousedown)="open()">
    @for (opt of selected; track opt.id) {
      <span class="chip">
        {{ opt.label }}&nbsp;<span class="chip__remove" (mousedown)="remove(opt, $event)">×</span>
      </span>
    }
    <input
      #input
      type="text"
      class="filter-chip-input__field mila-ms__input"
      [value]="queryText"
      [placeholder]="selected.length ? '' : placeholder"
      (input)="onInput(input.value)"
      (focus)="open()"
    />
    @if (isLoading && !rootOptions.length) {
      <span class="mila-ms__spinner" aria-hidden="true"></span>
    }
  </div>

  @if (isOpen) {
    <div class="mila-ms__list mila-ms__list--tree">
      @for (opt of rootOptions; track opt.id) {
        <mila-multi-select-tree-item
          [item]="opt"
          [fetchPage]="fetchPage"
          [selectedIds]="selectedIds"
          (select)="onTreeSelect($event)"
        ></mila-multi-select-tree-item>
      }
      @if (!isLoading && !rootOptions.length) {
        <div class="mila-ms__empty">No matches{{ queryText ? ' for "' + queryText + '"' : '' }}.</div>
      }
    </div>
  }

  @if (limitMessage) {
    <p class="mila-ms__limit">{{ limitMessage }}</p>
  }

</div>
